import {
    compose,
    concat,
    cond,
    either,
    equals,
    includes,
    join,
    map,
    propSatisfies,
    startsWith,
    T,
    when,
    __,
} from 'ramda';
import { columnTypes } from '@qdabra/forms-shared/sharePoint';

const {
    SP_TYPE_ATTACHMENTS,
    SP_TYPE_LOOKUP,
    SP_TYPE_LOOKUP_MULTI,
    SP_TYPE_USER,
    SP_TYPE_USER_MULTI,
} = columnTypes;


const convertNameByType = (type, internalName) => {
    switch (type) {
        case SP_TYPE_LOOKUP:
        case SP_TYPE_LOOKUP_MULTI:
            return internalName + 'Id';
        case SP_TYPE_ATTACHMENTS:
            return 'AttachmentFiles';
        default:
            return internalName;
    }
};

// (String, String) -> String
export const sanitizeFieldName = compose(
    when(startsWith('_'), concat('OData_')),
    convertNameByType,
);

const isPersonType = includes(__, [SP_TYPE_USER, SP_TYPE_USER_MULTI]);
const isAttachmentType = equals(SP_TYPE_ATTACHMENTS);

export const isPersonField = propSatisfies(isPersonType, 'type');
export const isAttachmentField = propSatisfies(isAttachmentType, 'type');

export const isExpandField = either(isPersonField, isAttachmentField);
export const isExpandLookupKindField = isPersonField;

export const getAndSanitizeInternalName = ({ internalName, type }) =>
    sanitizeFieldName(type, internalName);

// $select

const selectProperties = (properties) => compose(
    join(','),
    (name) => map((p) => `${name}/${p}`, properties),
    getAndSanitizeInternalName,
);

const personFieldSelect =
    selectProperties(['Title', 'Name']);

const attachmentSelect =
    selectProperties(['ServerRelativeUrl', 'FileName']);

export const buildFieldSelect = cond([
    [isPersonField, personFieldSelect],
    [isAttachmentField, attachmentSelect],
    [T, getAndSanitizeInternalName],
]);

